import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectBuyPackageModalData } from '../../../../../../selectors/buyPackageModal';
import { capitalize } from '../../../../../../utils/string';
import { ListItem } from '../ListItem';
import { mapCategories } from './utils';
import { Categories } from './Categories';

export const CategoriesContainer = () => {
  const data = useSelector(selectBuyPackageModalData);

  const { categoriesView } = data;

  const categories = mapCategories(data.categoriesView);

  if (categories.length > 1) {
    return <Categories categories={categories} />;
  }

  return <ListItem title="Категории" content={capitalize(categoriesView)} />;
};
